import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/assets/logos/logo-johndoe.svg")